import { createContext, useContext, type ReactNode } from 'react'
import { getEnvConfig, type RuntimeEnvConfig } from '@/lib/runtime-env'

const EnvContext = createContext<RuntimeEnvConfig | null>(null)

export function EnvProvider({ children }: { children: ReactNode }) {
  return <EnvContext.Provider value={getEnvConfig()}>{children}</EnvContext.Provider>
}

export function useEnv() {
  const env = useContext(EnvContext)
  if (!env) {
    throw new Error('useEnv must be used within EnvProvider')
  }
  return env
}
